import {
    postData,
  } from "../../api";

export const BellCountIncrementor = async (data) => {
    try {
      const res = await postData(
        `/incrementCount`,data
      );
  
      return res;
    } catch (error) {
      console.log(error);
    }
  };
